<template>
    <!-- <el-scrollbar class="student_learn_center" :native="false"> -->
    <div class="learning">
        <div class="learn_center">
            <div class="news_title">
                <div class="header">
                    <span class="class_label">班级名称</span>
                    <el-select
                        style="z-index:999"
                        ref="classNameRef"
                        v-model="selectClassGradId"
                        clearable
                        placeholder="请选择"
                        @change="changeSelectClassGrad"
                    >
                        <el-option v-for="item in classGradData" :key="item.c_id" :label="item.c_name" :value="item.c_id"> </el-option>
                    </el-select>
                </div>
                <p class="label_title">课程概览模块</p>
                <el-table
                    :data="courseOverviewData"
                    stripe
                    style="width: 100%; flex: 1; border: 1px solid #EBEEF5; border-radius: 4px;"
                    :header-cell-style="headStyle"
                    :cell-style="cellStyle"
                >
                    <el-table-column prop="course_name" label="课程名称" width="220"> </el-table-column>
                    <el-table-column prop="belong_term" label="所属学期" width="180"> </el-table-column>
                    <el-table-column prop="progress_rate" label="课程进度"> </el-table-column>
                    <el-table-column prop="student_num" label="班级人数" width="180"> </el-table-column>
                    <el-table-column prop="training_num" label="实训数量" width="180"> </el-table-column>
                    <el-table-column prop="exam_num" label="小测数量"> </el-table-column>
                </el-table>
                <p class="label_title">课程导学模块</p>
                <el-table
                    :data="curriculumGuidanceData"
                    stripe
                    style="width: 100%;  flex: 1; border: 1px solid #EBEEF5; border-radius: 4px;"
                    :header-cell-style="headStyle"
                    :cell-style="cellStyle"
                >
                    <el-table-column prop="course_name" label="课程名称" width="220"> </el-table-column>
                    <el-table-column prop="course_desc" label="课程整体情况"> </el-table-column>
                    <el-table-column label="操作" width="180">
                        <template slot-scope="scope">
                            <span style="color:#006EFF; cursor: pointer;" @click="getCurriculumDetail(scope.row.course_id)">课程详情</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div>
                <!-- <div class="classMain">
                <span class="className" :class="{ activeClassName: index == activeIndex }"
                    v-for="(item, index) in curriculumGuidanceData" @click="clickClassName(item, index)">{{
                        item.course_name }}</span>
            </div>
           
                <div>
                    <span>学生名称</span>
                    <el-select v-model="selectStudentId" placeholder="请选择" @change="changeSelectStudent">
                        <el-option v-for="item in studentList" :key="item.s_id" :label="item.s_name" :value="item.s_id">
                        </el-option>
                    </el-select>
                </div> -->
                <div class="job">
                    <div class="student_header">
                        <span class="class_label">课程:</span>
                        <el-select
                            style="z-index:999"
                            ref="classNameRef"
                            v-model="selectCourseId"
                            clearable
                            placeholder="请选择"
                            @change="clickClassName"
                        >
                            <el-option
                                v-for="item in curriculumGuidanceData"
                                :key="item.course_id"
                                :label="item.course_name"
                                :value="item.course_id"
                            >
                            </el-option>
                        </el-select>
                        <span class="class_label stu_class_label">学生:</span>
                        <el-select v-model="selectStudentId" placeholder="请选择" @change="changeSelectStudent">
                            <el-option v-for="item in studentList" :key="item.s_id" :label="item.s_name" :value="item.s_id"> </el-option>
                        </el-select>
                    </div>
                    <p class="label_title">作业模块</p>
                    <div class="show_botton">
                        <span class="lable">名称:</span>
                        <el-input v-model="job.searchJobNameKey" placeholder="请输入作业名称" @blur="getJobData"></el-input>
                        <span class="lable status_lable">状态</span>
                        <el-select v-model="job.selectJobStatus" placeholder="请选择" @change="changeSelectJobStatus">
                            <el-option v-for="item in jobStatusOption" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-table
                        :data="jobData"
                        stripe
                        style="width: 100%; min-height: 350px;  flex: 1; border: 1px solid #EBEEF5; border-radius: 4px;"
                        :header-cell-style="headStyle"
                        :cell-style="cellStyle"
                    >
                        <el-table-column prop="name" label="作业名称" width="560"> </el-table-column>
                        <el-table-column prop="item_state" label="作业状态">
                            <template slot-scope="scope">
                                <!-- {{ scope.row.item_state == 1 ? "进行中" : "已结束" }} -->
                                <span v-if="scope.row.item_state == 1" style="display: flex;align-items: center;"
                                    ><span
                                        class="biaojicircle"
                                        style="background-color: #2FC359 ; width: 6px;height: 6px; display: inline-block;"
                                    ></span
                                    >进行中</span
                                >
                                <span v-else style="display: flex;align-items: center;">
                                    <span style="background-color: #FF2323 ; width: 6px;height: 6px; display: inline-block;"></span
                                    >已结束</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="提交状态">
                            <template slot-scope="scope">
                                {{ scope.row.status == 0 ? "未提交" : "已提交" }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="score" label="分值"> </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-link style="color:#006EFF;" :underline="false" @click="getJobDetail(scope.row)">查看详情</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleJobSizeChange"
                            @current-change="handleJobCurrentChange"
                            :current-page.sync="job.page"
                            :page-size="job.limit"
                            layout="prev, pager, next, jumper"
                            :total="job.total"
                        >
                        </el-pagination>
                    </div>

                    <p class="label_title">考试模块</p>
                    <div class="show_botton">
                        <span class="lable">名称:</span>
                        <el-input
                            v-model="pTraining.searchJobNameKey"
                            placeholder="请输入考试名称"
                            @blur="getPracticalTrainingData"
                        ></el-input>
                        <span class="lable status_lable">状态</span>
                        <el-select v-model="pTraining.selectJobStatus" placeholder="请选择" @change="getPracticalTrainingData">
                            <el-option v-for="item in jobStatusOption" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-table
                        :data="practicalTrainingData"
                        stripe
                        style="width: 100%;min-height: 350px;  flex: 1; border: 1px solid #EBEEF5; border-bottom: none; border-radius: 4px;"
                        :header-cell-style="headStyle"
                        :cell-style="cellStyle"
                    >
                        <el-table-column prop="name" label="考试名称" width="560"> </el-table-column>
                        <el-table-column prop="item_state" label="考试状态">
                            <template slot-scope="scope">
                                <!-- {{ scope.row.item_state == 1 ? "进行中" : "已结束" }} -->
                                <span v-if="scope.row.item_state == 1" style="display: flex;align-items: center;"
                                    ><span
                                        class="biaojicircle"
                                        style="background-color: #2FC359 ; width: 6px;height: 6px; display: inline-block;"
                                    ></span
                                    >进行中</span
                                >
                                <span v-else style="display: flex;align-items: center;">
                                    <span style="background-color: #FF2323 ; width: 6px;height: 6px; display: inline-block;"></span
                                    >已结束</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="提交状态">
                            <template slot-scope="scope">
                                {{ scope.row.status == 0 ? "未提交" : "已提交" }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="score" label="分值"> </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-link style="color:#006EFF;" :underline="false" @click="getTrainingDetail(scope.row)">查看详情</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handlepTrainingSizeChange"
                            @current-change="handlepTrainingCurrentChange"
                            :current-page.sync="pTraining.page"
                            :page-size="pTraining.limit"
                            layout="prev, pager, next, jumper"
                            :total="pTraining.total"
                        >
                        </el-pagination>
                    </div>

                    <p class="label_title">成绩模块</p>

                    <div class="score">
                        <div class="score_item" v-for="(item, index) in scoreData">
                            <span>{{ item.name }}</span>
                            <el-progress
                                v-if="index == 0 || index == 2"
                                type="circle"
                                :percentage="parseFloat(scoreProcess[item.value].replace('%', ''))"
                                color="#165DFF"
                            ></el-progress>
                            <el-progress
                                v-else
                                type="circle"
                                :percentage="parseFloat(scoreProcess[item.value].replace('%', ''))"
                                color="#14C9C9"
                            ></el-progress>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- </el-scrollbar> -->
</template>

<script>
export default {
    data() {
        return {
            classGradData: [], //班级列表
            courseOverviewData: [], //课程概览模块
            curriculumGuidanceData: [], //课程导学模块
            selectClassGradId: "",
            selectClassName: "",
            activeIndex: 0,
            selectCourseId: "",
            studentList: [], //学生列表
            selectStudentId: "",
            selectStudentName: "",
            jobData: [], //作业数据

            jobStatusOption: [
                {
                    label: "全部",
                    value: "",
                },
                {
                    label: "进行中",
                    value: 1,
                },
                {
                    label: "已结束",
                    value: 2,
                },
            ],
            job: {
                page: 1,
                limit: 5,
                selectJobStatus: "",
                searchJobNameKey: "",
                total: 0,
            },
            practicalTrainingData: [], //考试数据  实训
            pTraining: {
                page: 1,
                limit: 5,
                selectJobStatus: "",
                searchJobNameKey: "",
                total: 0,
            },
            scoreProcess: {
                progress_rate: "0%", //课件学习进度
                sign_rate: "0%", //课堂活动进度
                exam_rate: "0%", //作业提交率
                shixun_rate: "0%", //考试提交率
            },
            scoreData: [
                {
                    name: "课件学习进度",
                    value: "progress_rate",
                },
                {
                    name: "课堂活动",
                    value: "sign_rate",
                },
                {
                    name: "作业提交率",
                    value: "exam_rate",
                },
                {
                    name: "考试提交率",
                    value: "shixun_rate",
                },
            ],
        };
    },
    methods: {
        headStyle() {
            return "background: #FAFAFA; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;";
        },
        cellStyle() {
            return "padding-left: 24px; height: 60px; color: #333;";
        },
        getClassList() {
            let params = {
                no_paging: 1,
            };
            this.$shttp.axiosGetBy(this.$api.statistics, params, (res) => {
                if (res.code === 200) {
                    this.classGradData = res.data.data;
                    console.log(res.data.data, "res.data.data");
                    this.selectClassGradId = this.classGradData.length > 0 ? this.classGradData[0].c_id : "";
                    // this.selectClassName=this.classGradData.length > 0 ? this.classGradData[0].c_name : ""

                    this.getCourseOverviewData();
                    // this.getStudentList()
                }
            });
        },
        // 获取课程概览数据和导学数据
        getCourseOverviewData() {
            let params = {
                class_id: this.selectClassGradId,
            };
            this.$shttp.axiosGetBy(this.$api.adminGetCourseList, params, (res) => {
                // console.log(res, "课程选择模块");
                if (res.code == 200) {
                    this.courseOverviewData = res.data.overview;
                    this.curriculumGuidanceData = res.data.guide;
                    this.selectCourseId = this.curriculumGuidanceData.length > 0 ? this.curriculumGuidanceData[0].course_id : "";
                }

                // this.selectClassName=this.curriculumGuidanceData.length > 0 ? this.curriculumGuidanceData[0].course_name : ""
                this.getStudentList();
            });
        },
        // 选中班级
        changeSelectClassGrad(val) {
            this.getCourseOverviewData();
        },
        // 查看课程详情
        getCurriculumDetail(id) {
            this.$router.push({ path: "/qualityCourse/teacher/index", query: { course_id: id } });
        },
        // 切换课程
        clickClassName(val, index) {
            // this.activeIndex = index
            // this.selectCourseId = val.course_id
            this.getJobData();
            this.getPracticalTrainingData();
        },
        // 获取学生列表
        getStudentList() {
            let params = {
                type: "all",
                c_id: this.selectClassGradId,
            };
            this.$shttp.axiosGetBy(
                this.$api.showStudent,
                params,
                (res) => {
                    if (res.code === 200) {
                        if (res.data.length) {
                            this.studentList = res.data;
                            console.log(this.studentList, "学生列表");
                            this.selectStudentId = res.data[0].s_id;
                            this.selectStudentName = res.data[0].s_name;
                            this.selectClassName = res.data[0].c_name;
                            this.getJobData();
                            this.getPracticalTrainingData();
                            this.getAnalysisGrade();
                        }
                    }
                },
                (err) => {
                    console.log(err);
                },
            );
        },
        // 选中学生
        changeSelectStudent(val) {
            // this.selectStudentName=
            let obj = this.studentList.find((data) => val == data.s_id);
            if (obj) {
                this.selectStudentName = obj.s_name;
                this.selectClassName = obj.c_name;
            }
            this.getJobData();
            this.getPracticalTrainingData();
            this.getAnalysisGrade();
        },
        // 选中作业状态
        changeSelectJobStatus(val) {
            this.job.selectJobStatus = val;
            this.getJobData();
        },
        // 获取作业数据
        getJobData() {
            let params = {
                class_id: this.selectClassGradId,
                s_id: this.selectStudentId,
                course_id: this.selectCourseId,
                page: this.job.page,
                limit: this.job.limit,
                name: this.job.searchJobNameKey,
                item_state: this.job.selectJobStatus,
            };
            this.$shttp.axiosGetBy(
                this.$api.adminGetExamList,
                params,
                (res) => {
                    if (res.code === 200) {
                        console.log(res, "获取作业数据");
                        this.jobData = res.data.list;
                        this.job.total = res.data.total;
                    }
                },
                (err) => {
                    console.log(err);
                },
            );
        },
        // 查看作业详情
        getJobDetail(item) {
            if (item.status != 2) {
                this.$message.warning("该学生未提交作业");
                return false;
            }
            this.$router.push({
                path: "/learning/allApprovedDetail",
                query: {
                    quizId: item.id,
                    studentId: this.selectStudentId,
                    classId: this.selectClassGradId,
                    className: this.selectClassName,
                    paperName: item.name,
                    studentName: this.selectStudentName,
                },
            });
        },
        // 作业列表分页
        handleJobSizeChange(val) {
            this.job.limit = val;
            this.getJobData();
        },
        handleJobCurrentChange(val) {
            this.job.page = val;
            this.getJobData();
        },
        // 获取实训数据
        getPracticalTrainingData() {
            let params = {
                class_id: this.selectClassGradId,
                s_id: this.selectStudentId,
                course_id: this.selectCourseId,
                page: this.pTraining.page,
                limit: this.pTraining.limit,
                name: this.pTraining.searchJobNameKey,
                item_state: this.pTraining.selectJobStatus,
            };
            this.$shttp.axiosGetBy(
                this.$api.adminGetShixunList,
                params,
                (res) => {
                    if (res.code === 200) {
                        console.log(res, "获取实训数据");
                        this.practicalTrainingData = res.data.list;
                        this.pTraining.total = res.data.total;
                    }
                },
                (err) => {
                    console.log(err);
                },
            );
        },

        // 查看实训详情
        getTrainingDetail(item) {
            if (item.status != 2) {
                this.$message.warning("该学生未提交实训");
                return false;
            }
            this.$router.push({
                path: "/learning/practicalDetail",
                query: {
                    p_id: item.project_id,
                    sx_id: item.id,
                    className: this.selectClassName,
                },
            });
        },
        // 选中实训状态
        changeSelectTrainStatus() {
            this.getPracticalTrainingData();
        },
        // 实训列表分页
        handlepTrainingSizeChange(val) {
            this.pTraining.limit = val;
            this.getPracticalTrainingData();
        },
        handlepTrainingCurrentChange(val) {
            this.pTraining.page = val;
            this.getPracticalTrainingData();
        },
        // 获取成绩进度
        getAnalysisGrade() {
            let params = {
                class_id: this.selectClassGradId,
                s_id: this.selectStudentId,
            };
            this.$shttp.axiosGetBy(
                this.$api.adminAnalysisGrade,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.scoreProcess = res.data;
                        // console.log("成绩进度",this.scoreProcess);
                    }
                },
                (err) => {
                    console.log(err);
                },
            );
        },
    },
    mounted() {
        this.getClassList();
    },
};
</script>

<style scoped lang="scss">
.learning {
    width: 100%;
    box-sizing: border-box;
    background-color: #f4f5f9;
    display: flex;
    justify-content: center;
}

.learn_center {
    width: 70%;
    margin-top: 20px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #ffffff;

    .news_title {
        .header {
            width: 100%;
            height: 48px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            // border-bottom: 1px solid #EAEDF4;

            .class_label {
                padding-right: 22px;
            }
        }

        .label_title {
            position: relative;
            margin: 20px 0;
            padding-left: 20px;
            height: 20px;

            /* 为了给竖条留出空间 */
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                /* 竖条的宽度 */
                height: 100%;
                /* 竖条的高度，与内容区域高度一致 */
                background-color: #409eff;
                /* 竖条的颜色 */
            }
        }
    }
}

.job {
    .student_header {
        margin-top: 30px;
        // border-bottom: 1px solid #EEEEEE ;

        .class_label {
            padding-right: 22px;
        }

        .stu_class_label {
            padding-left: 40px;
        }
    }

    .label_title {
        position: relative;
        margin: 20px 0;
        padding-left: 20px;
        height: 20px;

        /* 为了给竖条留出空间 */
        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 4px;
            /* 竖条的宽度 */
            height: 100%;
            /* 竖条的高度，与内容区域高度一致 */
            background-color: #409eff;
            /* 竖条的颜色 */
        }
    }

    .pagination {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
}

.classMain {
    // height: 50px;
    // background-color: pink;
    // display: flex;
    // align-items: center;
    margin-top: 20px;
    border-bottom: 1px solid rgb(209, 207, 207);
    margin-bottom: 20px;

    .className {
        margin-left: 20px;
        padding: 15px 0;
        display: inline-block;
    }

    .activeClassName {
        border-bottom: 3px solid rgb(108, 156, 233);
    }
}

.show_botton {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .lable {
        display: inline-block;
        margin-right: 22px;
    }

    .status_lable {
        margin-left: 40px;
    }

    .el-input {
        width: 230px !important;
    }
}

.score {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .score_item {
        width: 289px;
        height: 128px;
        background: #f4f5f9;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #ecf0f3;
        display: flex;
        align-items: center;
        padding: 20px 20px;
        box-sizing: border-box;
        justify-content: space-between;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        ::v-deep .el-progress-circle {
            width: 98px !important;
            height: 98px !important;
        }
    }
}

::v-deep .el-input__inner {
    width: 230px !important;
}

.el-pagination {
    ::v-deep .el-input__inner {
        width: 50px !important;
        height: 28px;
    }
}
</style>
